<template>
  <div class="main">
    <div class="body">
      <TableUser @editUser="editUser" :items="items" :busy="busy" />
    </div>
    <div class="footer">
      <div class="form-inline">
        <b-button class="btn-cancel" @click="cancel">ย้อนกลับ</b-button>
      </div>

      <div
        class="form-inline justify-content-center justify-content-sm-end"
        v-show="!busy"
      >
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="form.pageNo"
            :total-rows="rows"
            :per-page="form.perPage"
            class="m-md-0 page-item"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>

        <b-form-select
          class="mr-sm-3 select-page"
          v-model="form.perPage"
          @change="hanndleChangePerpage"
          :options="pageOptions"
        ></b-form-select>
      </div>
    </div>
  </div>
</template>

<script>
import TableUser from "../table/tableUser.vue";
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    form: {
      type: Object,
      default: () => {},
    },
    rows: {
      type: Number,
      default: 10,
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TableUser,
  },
  data() {
    return {
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
    };
  },
  mounted() {
    // this.getListUser();
  },
  methods: {
    editUser(obj) {
      this.$emit("editUser", obj);
    },
    pagination() {
      this.$emit("changeForm", this.form);
    },
    hanndleChangePerpage() {
      this.form.pageNo = 1;
      this.$emit("changeForm", this.form);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
  width: 100%;
}
.body {
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.btn-cancel {
  background: white;
  min-width: 100px;
}
.btn-cancel:hover {
  color: grey !important;
}
.btn-save {
  background: #b41bb4;
  color: white !important;
  border: none;
  min-width: 100px;
}
.footer {
  background: white;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
